<template>
  <div class="content-container gradient-animation">
    <title-with-breadcrumbs
      :title="'checkout.titles.checkout' | translate"
      class="mb-regular"
    ></title-with-breadcrumbs>
    <form id="payment-form" class="flex">
      <div class="flex-col">
        <div class="customer-details" :class="{ hidden: isPayment }">
          <h5 class="mb-small">
            {{ "checkout.titles.contact_info" | translate }}
          </h5>
          <label for="email">
            {{ "checkout.form.email" | translate }}
          </label>
          <input
            type="email"
            name="email"
            id="email"
            v-model="input.email"
            class="form-input"
          />
          <h5 class="mb-small mt-small">
            {{ "checkout.titles.shipping_information" | translate }}
          </h5>
          <div class="flex name-container">
            <div class="flex-col">
              <label for="first_name">
                {{ "checkout.form.first_name" | translate }}
              </label>
              <input
                type="text"
                name="first_name"
                id="first_name"
                v-model="input.first_name"
                class="form-input"
              />
            </div>
            <div class="flex-col">
              <label for="last_name">
                {{ "checkout.form.last_name" | translate }}
              </label>
              <input
                type="text"
                name="last_name"
                id="last_name"
                v-model="input.last_name"
                class="form-input"
              />
            </div>
          </div>
          <div class="flex name-container">
            <div class="flex-col">
              <label for="address1">
                {{ "checkout.form.address_1" | translate }}
              </label>
              <input
                type="text"
                name="address1"
                id="address1"
                v-model="input.address1"
                class="form-input"
              />
            </div>
            <div class="flex-col">
              <label for="address2">
                {{ "checkout.form.address_2" | translate }}
              </label>
              <input
                type="text"
                name="address2"
                id="address2"
                v-model="input.address2"
                class="form-input"
              />
            </div>
          </div>
          <div class="flex name-container">
            <div class="flex-col">
              <label for="city">
                {{ "checkout.form.city" | translate }}
              </label>
              <input
                type="text"
                name="city"
                id="city"
                v-model="input.city"
                class="form-input"
              />
            </div>
            <div class="flex-col">
              <label for="postal_code">
                {{ "checkout.form.postal_code" | translate }}
              </label>
              <input
                type="text"
                name="postal_code"
                v-model="input.postal_code"
                class="form-input"
              />
            </div>
          </div>
          <label for="country">
            {{ "checkout.form.country" | translate }}
          </label>
          <input
            type="text"
            name="country"
            class="form-input mb-small"
            disabled
            placeholder="Switzerland"
          />
          <div class="card-container">
            <h5 class="mb-small">
              {{ "checkout.titles.card_details" | translate }}
            </h5>
            <div class="flex save-card">
              <label for="save-card">
                {{ "checkout.form.save_card" | translate }}
              </label>
              <input
                id="save-card"
                type="checkbox"
                name="save-card"
                v-model="input.save_card"
              />
            </div>
            <input
              type="text"
              name="text"
              id="card_holder"
              v-model="input.card_holder"
              :placeholder="'checkout.form.card_holder_name' | translate"
              class="form-input"
            />

            <div class="card" id="card-element">
              <!-- Elements will create input elements here -->
            </div>

            <!-- We'll put the error messages in this element -->
            <div id="card-errors" role="alert"></div>
          </div>
          <div class="confirmation-container">
            <h5 class="mb-small">
              {{ "checkout.titles.confirmation" | translate }}
            </h5>
            <p>{{ "checkout.titles.confirmation_info" | translate }}</p>
            <button
              class="button salmon disabled"
              @click="showPayment"
              :disabled="!field_validations"
            >
              {{ "checkout.titles.to_confirmation" | translate }}
            </button>
          </div>
        </div>
        <div class="flex-col payment" :class="{ visible: isPayment }">
          <div class="summary">
            <h4 class="mb-small">{{ "checkout.titles.review" | translate }}</h4>
            <p>{{ "checkout.titles.review_info" | translate }}</p>
            <div class="title-with-edit">
              <h5>
                {{ "checkout.titles.contact_info" | translate }}
              </h5>
              <i class="material-icons" @click="showDetails">edit</i>
            </div>

            <div class="horizontal-line"></div>
            <p>
              {{ "checkout.form.email" | translate }}: {{ this.input.email }}
            </p>
            <h5 class="mt-small">
              {{ "checkout.titles.shipping_information" | translate }}
            </h5>
            <div class="horizontal-line"></div>
            <div class="flex">
              <p>
                {{ "checkout.form.first_name" | translate }}:
                {{ this.input.first_name }}
              </p>
              <p>
                {{ "checkout.form.last_name" | translate }}:
                {{ this.input.last_name }}
              </p>
            </div>
            <div class="flex">
              <p>
                {{ "checkout.form.address_1" | translate }}:
                {{ this.input.address1 }}
              </p>
              <p v-if="this.input.address2">
                {{ "checkout.form.address_2" | translate }}:
                {{ this.input.address2 }}
              </p>
            </div>
            <div class="flex">
              <p>
                {{ "checkout.form.city" | translate }}: {{ this.input.city }}
              </p>
              <p>
                {{ "checkout.form.postal_code" | translate }}:
                {{ this.input.postal_code }}
              </p>
            </div>

            <h5>
              {{ "checkout.titles.card_details" | translate }}
            </h5>
            <div class="horizontal-line"></div>
            <p>
              {{ "checkout.form.card_holder_name" | translate }}:
              {{ this.input.card_holder }}
            </p>
            <p>
              {{ "checkout.form.card" | translate }}:
              {{ this.card }}
            </p>
          </div>
        </div>
        <div v-if="isPayment" class="stores-container">
          <div class="white-box">
            <h5>{{ "checkout.titles.confirm_pay" | translate }}</h5>
            <p>{{ "checkout.titles.payment_info" | translate }}</p>
          </div>
          <store-checkout
            v-for="(order, j) in cart.orders"
            :key="j"
            :input="input"
            :card="card"
            :stripeSecret="stripeSecretsObject[order.store.storeName]"
            :stripeSetup="stripeSetups[order.store.storeName]"
            :platformStripeSetup="platformStripeSetup"
            :order="order"
          ></store-checkout>
        </div>
      </div>
      <div class="flex-col">
        <price-breakdown></price-breakdown>
      </div>
    </form>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import PriceBreakdown from "../components/molecules/price-breakdown";
import {
  verifyGuestUserToken,
  getPaymentIntent,
  checkoutCart,
  getHydratedCart as getServerCart,
  getStripeIdForStore,
  getStoreById
} from "../services/api";
import { cartMethods, userMixin } from "../mixins";
import TitleWithBreadcrumbs from "../components/atoms/title-with-breadcrumbs.vue";
import StoreCheckout from "../components/molecules/store-checkout.vue";

export default {
  name: "CartPage",
  components: { PriceBreakdown, TitleWithBreadcrumbs, StoreCheckout },
  data() {
    return {
      platformStripeSetup: null,
      stripeSetups: null,
      stripeToken: process.env.VUE_APP_STRIPE_KEY,
      stripeSecretsObject: null,
      clientId: null,
      orderStatuses: [],
      input: {
        order_id: null,
        first_name: null,
        last_name: null,
        address1: null,
        address2: null,
        postal_code: null,
        city: null,
        email: null,
        card_holder: null,
        save_card: false
      },
      card: null,
      isPayment: false,
      isConfirmation: false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  mixins: [userMixin, cartMethods],
  methods: {
    isEmailValid() {
      return this.input.email === ""
        ? true
        : this.reg.test(this.input.email)
        ? true
        : false;
    },
    async loadStripeSetups() {
      // eslint-disable-next-line no-undef
      const { stripeSecretsObject } = this;
      const setups = await Promise.all(
        Object.keys(stripeSecretsObject).map(async storeName => {
          const { clientId } = stripeSecretsObject[storeName];
          const stripeSetup = window.Stripe(this.stripeToken, {
            stripeAccount: clientId
          }); //eslint-ignore;
          return { [storeName]: stripeSetup };
        })
      );
      const setupsByStore = setups.reduce(
        (acc, curr) => ({ ...acc, ...curr }),
        {}
      );
      const platformStripeSetup = window.Stripe(this.stripeToken);
      this.platformStripeSetup = platformStripeSetup;
      this.stripeSetups = setupsByStore;
    },
    async getCart() {
      const cart_id =
        (this.$route.params && this.$route.params.cartId) ||
        (this.cart && this.cart.cart_id);
      if (!cart_id) {
        // console.log("No cart found");
        return;
      }
      const response = await getServerCart(cart_id);
      if (response.status === 200) {
        this.setCart(response.data);
        this.input.order_id = this.cart.orders[0].order_id;
        // console.log("Cart set");
      } else {
        this.handleHttpError(response);
      }
    },
    ...mapMutations({
      setLocalCart: "cart/setCart"
    }),
    async getClientId(order) {
      const { store_id } = order;
      const clientIdResult = await getStripeIdForStore(store_id);
      if (clientIdResult.status === 200) {
        return clientIdResult.data;
      } else {
        // console.log("Client Ids failed to load");
      }
    },
    async getPaymentIntentSecret(order) {
      const { order_id } = order;
      const paymentIntentSecretResult = await getPaymentIntent(order_id);
      if (paymentIntentSecretResult.status === 200) {
        return paymentIntentSecretResult.data;
      } else {
        // console.log("Payment Intent secrets failed to load");
      }
    },
    async getValuesByStoreId(orders, valueGetter) {
      const values = await Promise.all(
        orders.map(async order => {
          const value = await valueGetter(order);
          const storeId = order.store_id.replace(/"/gi, "");
          return {
            [storeId]: value
          };
        })
      );
      const byStoreIdObject = values.reduce(
        (acc, curr) => ({ ...acc, ...curr }),
        {}
      );
      return byStoreIdObject;
    },
    async getStore(order) {
      const { store_id } = order;
      const storeResult = await getStoreById(store_id);
      if (storeResult.status === 200) {
        return storeResult.data;
      } else {
        // console.log("Payment Intent secrets failed to load");
      }
    },
    async getStripeSecrets() {
      const orders = this.cart.orders;
      if (!orders.length) {
        // console.log("No orders available found");
        return;
      }
      const valueGetters = [this.getPaymentIntentSecret, this.getClientId];
      const valuePromises = Promise.all(
        valueGetters.map(valueGetter =>
          this.getValuesByStoreId(orders, valueGetter)
        )
      );
      const storesPromise = Promise.all(
        orders.map(order => this.getStore(order))
      );
      const [values, stores] = await Promise.all([
        valuePromises,
        storesPromise
      ]);
      this.stripeSecretsObject = stores.reduce((acc, store) => {
        const { _id: storeId, storeName } = store;
        const [paymentIntentSecret, clientId] = values.map(o => o[storeId]);
        return {
          ...acc,
          [storeName]: {
            paymentIntentSecret,
            clientId
          }
        };
      }, {});
    },
    goToConfirmation(event, card) {
      event.preventDefault();
      this.isConfirmation = true;
      this.card = card;
      // console.log(this.isConfirmation);
    },
    async handleStripeSubmit(event, card) {
      event.preventDefault();
      this.card = card;
      for (const storeName of Object.keys(this.stripeSecretsObject)) {
        await this.handleStripeSubmitForStore(storeName);
      }
    },
    async handleStripeSubmitForStore(storeName) {
      const stripeOptions = {
        payment_method: {
          card: this.card,
          billing_details: {
            name: this.input.card_holder,
            email: this.input.email,
            address: {
              line1: this.input.address1,
              line2: this.input.address2,
              postal_code: this.input.postal_code,
              city: this.input.city
            }
          }
        }
      };
      if (this.input.save_card) {
        stripeOptions["setup_future_usage"] = "off_session";
      }
      const { paymentIntentSecret } = this.stripeSecretsObject[storeName];
      const stripeSetup = this.stripeSetups[storeName];
      const result = await stripeSetup.confirmCardPayment(
        paymentIntentSecret,
        stripeOptions
      );

      if (result.error) {
        // Show error to your customer (e.g., insufficient funds)
        //console.log(result.error.message);
      } else {
        // The payment has been processed!
        if (result.paymentIntent.status === "requires_capture") {
          // console.log("Success in payment!");
          // Show a success message to your customer
          // There's a risk of the customer closing the window before callback
          // execution. Set up a webhook or plugin to listen for the
          // payment_intent.succeeded event that handles any business critical
          // post-payment actions.
        }
      }
    },
    async cartCompleted() {
      if (this.cart.status !== "Closed") {
        await checkoutCart(this.cart);
        this.setCart({ ...this.cart, status: "Closed" });
      }
    },
    async mountStripe() {
      var elements = this.platformStripeSetup.elements();
      var style = {
        base: {
          color: "#32325d"
        }
      };

      var card = elements.create("card", { style: style });
      card.mount("#card-element");

      var form = document.getElementById("payment-form");

      form.addEventListener("submit", ev => this.saveCard(ev, card));
    },
    saveCard(event, card) {
      event.preventDefault();
      this.card = card;
    },
    showPayment() {
      this.isPayment = true;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    showDetails() {
      this.isPayment = false;
    }
  },
  computed: {
    field_validations() {
      const validators = {
        first_name: first_name => !!first_name,
        last_name: last_name => !!last_name,
        email: this.isEmailValid,
        address1: address1 => !!address1,
        postal_code: postal_code => !!postal_code,
        city: city => !!city
      };
      const results = Object.keys(validators).reduce((acc, key) => {
        const result =
          (validators[key] && validators[key](this.input[key], this.input)) ||
          !validators[key];
        return { ...acc, [key]: result };
      }, {});
      var values = Object.values(results);
      let isValid = values.every(e => e === true);
      return isValid;
    }
  },
  async beforeMount() {
    await this.getCart();
    await this.getStripeSecrets();
    await this.loadStripeSetups();
    await this.mountStripe();
  },
  async beforeRouteEnter(to, from, next) {
    await next(async vm => {
      const goToLogin = (guestVerifyFailed = false) => {
        // console.log("Going to login");
        const currentPath = to.path;
        return vm.$router.replace({
          name: "Login",
          query: {
            returnPath: currentPath,
            checkout: true,
            cartId: "temportalCartId",
            guestVerifyFailed
          }
        });
      };
      if (!vm.hasUser) {
        const guestToken =
          to.query.verificationToken ||
          (await localStorage.getItem("guestToken"));
        if (guestToken) {
          const verified = await verifyGuestUserToken(guestToken);
          // console.log("Verified: " + verified.data);
          if (verified.data) {
            localStorage.setItem("guestToken", guestToken);
            vm.guestToken = guestToken;
          } else {
            goToLogin(true);
          }
        } else {
          goToLogin();
        }
      }
    });
  },
  async beforeRouteUpdate() {
    this.getCart();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.content-container {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.flex {
  flex-direction: column;

  @media (min-width: $breakpoint-md) {
    flex-direction: row;
  }

  .flex-col {
    @media (min-width: $breakpoint-md) {
      width: 65%;
    }

    &:nth-of-type(2) {
      @media (min-width: $breakpoint-md) {
        padding-left: 2rem;
        width: 35%;
      }

      @media (min-width: $breakpoint-lg) {
        padding-left: 3rem;
      }
    }
  }
}

.button.salmon {
  box-shadow: none;
  margin-top: 2rem;
  text-align: center;
  margin-bottom: 2rem;
}

.save-card {
  align-items: center;
  margin-bottom: 1rem;
  flex-direction: row;

  label {
    margin: 0;
  }

  input {
    margin-left: 0.5rem;
  }
}

.card {
  height: 3rem;
  border: 1px solid $brand-gray-medium;
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 0;
  margin-bottom: 2rem;
}

.customer-details {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;

  &.hidden {
    display: none;
  }
}

.horizontal-line {
  height: 1px;
  width: 100%;
  background-color: $brand-black;
  margin-bottom: 1rem;
}

.name-container {
  justify-content: space-between;
  flex-direction: row !important;

  label {
    white-space: nowrap;
  }

  .flex-col {
    width: 48% !important;
    padding: 0 !important;
  }
}

.summary {
  background-color: $brand-white;
  padding: 1rem;
  position: relative;
  margin-bottom: 1rem;

  .material-icons {
    padding: 0.75rem;
    color: $brand-gray;
  }

  .flex {
    p {
      margin-right: 1rem;
    }
  }

  .title-with-edit {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
}

.payment {
  display: none;
  width: 100% !important;
  padding: 0 !important;
  transition: all 0.5s ease-in-out;

  &.visible {
    display: initial;
  }
}

.form-container {
  display: flex;
  flex-direction: column;
}

.card-container {
  #card_holder {
    width: 100%;
    padding: 0.75rem;
  }
}

.confirmation-container {
  background-color: $brand-white;
  padding: 1rem;
  text-align: center;

  h5,
  p {
    text-align: left;
  }
}

.white-box {
  background-color: $brand-white;
  padding: 1rem;
}

.price-breakdown {
  position: sticky;
  top: 2rem;
}
</style>
